import { isCapabilityEnabled } from 'owa-capabilities';
import { newHeaderCapability } from 'owa-capabilities-definitions/lib/newHeaderCapability';
import type { PinnablePaneRegistration } from '../schema/PinnablePaneRegistrations';

export default function isMatchingPaneId(
    registration: PinnablePaneRegistration,
    flexPaneId: string
): boolean {
    const newHeaderEnabled = isCapabilityEnabled(newHeaderCapability);
    const keyToCompare = newHeaderEnabled ? 'headerPaneId' : 'flexPaneId';
    return registration[keyToCompare] === flexPaneId;
}
